<template>
    <div>
        <b-modal id="condition_modal"
                 modal-class="modal-register-success"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">

                <div class="close-modal" @click="hideModal()">
                    <img class="icon-close" src="@/assets/icon/ic-close3x.png" />
                </div>

                <div class="header">{{lbl.gift_detail.confirm_redeem.condition}}</div>

                <div class="modal-base-body">
                    <div>{{campaign.condition}}</div>
                   <!-- <div>Lorem ipsum dolor sit amet, cons ectetur adipiscing elit. Integer vitae augue magna. Curabitur bibendum lacus et tortor tincidunt, idmaximus quam pellentesque. Curabitur ultri ces, turpis vel porttitor porta, est justo faucibus lacus, et dignissim libero ex at metus.      Suspendisse vitae ligula eu mas sa feugiat lobortis eu sit amet nisl. Donec quis diam imperdiet, tristiqu e eros id, volutpat metus. Vestibulu m ante ipsum primis in faucibus or ci luctus et ultrices posuere cubilia Curae; Aliquam et gravida justo, at convallis velit.           Nam elementum, sapien nec lao reet posuere, diam ex ornare lorem, non feugiat justo elit quis orci. Lorem ipsum dolor sit amet, cons ectetur adipiscing elit. Integer vitae augue magna. Curabitur bibendum lacus et tortor tincidunt, idmaximus quam pellentesque. Curabitur ultri ces, turpis vel porttitor porta, est justo faucibus lacus, et dignissim libero ex at metus.      Suspendisse vitae ligula eu mas sa feugiat lobortis eu sit amet nisl. Donec quis diam imperdiet, tristiqu e eros id, volutpat metus. Vestibulu m ante ipsum primis in faucibus or ci luctus et ultrices posuere cubilia Curae; Aliquam et gravida justo, at convallis velit.           Nam elementum, sapien nec lao reet posuere, diam ex ornare lorem, non feugiat justo elit q</div> -->
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>


export default {
    name: "ConditionModal",
    props: {
        busModal: Object,
        view: String,
        lbl: Object,
        campaign: Object,
    },
    data: function() {
        return {
            modalSuccess: {
                id: 'register-success-',
                title: '',
                strBtnOk: '',
                message: '',
                tag: '',
            },
        };
    },
    created: function() {
        this.modalSuccess.id += this.view;
    },
    mounted: function() {

        this.busModal.$on('showModal', this.showModal);
    },
    methods: {
        showModal: function() {
            // debugger
            console.log("this.campaign",this.campaign);
            // this.modalSuccess.title = config.title;
            // this.modalSuccess.message = config.message;
            // this.modalSuccess.strBtnOk = Util.isEmptyStr(config.strBtnOk) ? 'Ok' : config.strBtnOk;
            // this.modalSuccess.tag = config.tag;
            this.$bvModal.show('condition_modal');
        },
        hideModal: function() {

            this.$emit('clickCloseCondition');
            this.$bvModal.hide('condition_modal');
        },
        clickContinue: function() {
            this.hideModal();
            if (this.modalSuccess.tag == "success") {
                this.$router.push('/profile');
            }

        },
    },
}
</script>
<style lang="scss" scoped>
    #condition_modal {

        .modal-base {

            .close-modal{
                text-align: right;

                .icon-close {
                    width: 15px;
                }
            }

            .header {
                font-size: 18px;
                font-weight: bold;
                padding-top: 5px;
                padding-bottom: 20px;

            }

            .modal-base-body {
                padding-bottom: 20px;
                font-size: 15px;
                line-height: 1.5;
            }
        }
    }
</style>
<style lang="scss">
#condition_modal {
    .modal-body {
        padding-bottom: 30px;
    }
    .modal-base-body {
        overflow: scroll;
        height: 60vh;
    }

}
</style>
